import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinViewerModule } from '@egjs/ngx-view360';
import { NgxStickySidebarModule } from '@smip/ngx-sticky-sidebar';
import { InlineSVGModule } from 'ng-inline-svg';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxCurrencyModule } from "ngx-currency";
import { NgxMaskModule } from 'ngx-mask';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { InputComponent } from 'src/app/shared/input/input.component';
import { DataService } from 'src/app/shared/service/data.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApartmentSelectComponent } from './pages/apartment-select/apartment-select.component';
import { ConfiguratorComponent } from './pages/configurator/configurator.component';
import { SuccessComponent } from './pages/configurator/success/success.component';
import { HomeComponent } from './pages/home/home.component';
import { SegmentsComponent } from './pages/segments/segments.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UiSwitchModule } from 'ngx-ui-switch';
import { LightgalleryModule } from 'lightgallery/angular/10';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ApartmentSelectComponent,
    SegmentsComponent,
    ConfiguratorComponent,
    SuccessComponent,
    InputComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    NgxMaskModule.forRoot(),
    HttpClientModule,
    CarouselModule,
    NgxStickySidebarModule.withConfig({ minWidth: 992 }),
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    AccordionModule.forRoot(),
    TooltipModule.forRoot(),
    NgxCurrencyModule,
    FormsModule,
    InlineSVGModule.forRoot(),
    ColorPickerModule,
    NgxSpinViewerModule,
    NgxSliderModule,
    DragDropModule,
    UiSwitchModule,
    LightgalleryModule
  ],
  providers: [
    DataService, 
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
